<script setup lang="ts"></script>

<template>
  <div
    :class="$style.detailedJobBlockWrapper"
    data-testid="detailedJobBlockWrapper"
  >
    <slot></slot>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobBlockWrapper {
  background-color: colors.$color-white;
  border: 1px solid colors.$color-brand-100;
  padding: variables.$pageMarginX;
}
</style>
